import icons from "url:../icons/icons.svg";

class View {
  _parentElement = document.querySelector(".dataRows");
  _spinnerElement = document.querySelector(".tableContainer");
  _search = document.querySelector("#submit_form");
  _input = document.querySelector("#search");
  _message = "incorrect response";

  render(data) {
    if (!data) return this.renderError();
    this._data = data;
    const markup = this._generateMarkup();
    document.querySelector(".spinner")?.remove();
    document.querySelector(".error")?.remove();
    this._parentElement.insertAdjacentHTML("afterbegin", markup);
  }

  _clear() {
    this._parentElement.innerHTML = "";
  }

  renderSpinner() {
    const markup = `
            <div class="spinner">
              <svg>
                <use href="${icons}#icon-loader"></use>
              </svg>
            </div>
        `;
    this._clear();
    this._spinnerElement.insertAdjacentHTML("beforeEnd", markup);
  }

  renderError(message = this._errorMessage) {
    const markup = `
          <div class = "error text-center">
            <p>${message}</p>
          </div>`;

    this._clear();
    this._spinnerElement.insertAdjacentHTML("beforeEnd", markup);
  }

  _generateMarkup() {
    return this._data.map(this._generateMarkupEle).join("");
  }

  _generateMarkupEle(user, idx) {
    return `
        <tr>
            <th scope="row">${idx + 1}</th>
            <td>${user.roll}</td>
            <td>${user.name}</td>
            <td> <a class = "hackerrank" href = "https://www.hackerrank.com/${
              user.hackerrank
            }">${user.hackerrankSolved}<a> </td>
            <td> <a class = "pp" href = "https://www.hackerrank.com/contests/programmer-planet-part-1/challenges">${
              user.ppSolved + user.siSolved
            }<a> </td>
            <td> <a class = "codechef" href = "https://www.codechef.com/users/${
              user.codechef
            }">${user.codechefSolved}<a> </td>
            <!--<td> <a class = "interviewbit" href = "https://www.interviewbit.com/profile/${
              user.interviewbit
            }">${user.interviewbitSolved}<a> </td>-->
            <td> <a class = "leetcode" href = "https://leetcode.com/${
              user.leetcode
            }">${user.leetcodeSolved}<a> </td>
            <td class = "overall">${user.overall}</td>
        </tr>`;
  }
}

export default new View();
